/**
 * @graphql cc
 */
import { useMemo } from 'react';

import { useProcessedCommentsDataState } from '@confluence/comments-data-manager/entry-points/useProcessedCommentsData.ts';

/**
 * @deprecated This type is deprecated and will be removed in a future version.
 * It was used to manage comment counts but is no longer needed as part of modernization.
 */
export type UseCommentCountsData = {
	unresolvedInlineCommentsCount: number;
	footerCommentsCount: number;
};

/**
 * @deprecated This hook is deprecated and will be removed in a future version.
 * It was used to fetch comment counts but is no longer needed as part of modernization.
 */
export const useCommentCounts = (_contentId: string): UseCommentCountsData => {
	// Get processed comment data from the Comments Data Manager store
	const { isDataProcessed, openInlineComments, openFooterComments } =
		useProcessedCommentsDataState();

	return useMemo(() => {
		if (isDataProcessed) {
			return {
				unresolvedInlineCommentsCount: openInlineComments.length,
				footerCommentsCount: openFooterComments.length,
			};
		}

		// Fallback when data hasn't loaded yet
		return {
			unresolvedInlineCommentsCount: 0,
			footerCommentsCount: 0,
		};
	}, [isDataProcessed, openInlineComments.length, openFooterComments.length]);
};
